export function transformUuidToId(data) {
    if (Array.isArray(data)) {
        return data.map(transformUuidToId);
    } else if (data && typeof data === "object" && data !== null) {
        const newObj = {};
        for (const [key, value] of Object.entries(data)) {
            const newKey = key === "uuid" ? "id" : key;
            newObj[newKey] = transformUuidToId(value);
        }
        return newObj;
    }
    return data;
}